import Button from '@material-ui/core/Button';
import React from 'react';
import { withStyles } from '@material-ui/core/styles';

const styles = {
  root: {
    fontSize: 16,
    display: 'block',
    margin: '14px auto 0',
  },
};

const ButtonLinkComponent = (props) => (
  <div>
    <Button {...props} />
  </div>
);

export const ButtonLink = withStyles(styles)(ButtonLinkComponent);
